import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that manages the product SKU display.
 * Updates the SKU when a variant is selected.
 *
 * @extends Component
 */
class ProductSku extends Component {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    const target = this.closest('.shopify-section, dialog, product-card');

    // Listen for variant update events
    target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, {
      signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  /**
   * Handles the variant update event and updates the SKU display.
   * @param {import('@theme/events').VariantUpdateEvent} event - The variant update event.
   */
  #onVariantUpdate = (event) => {
    // Check if this SKU component belongs to the product being updated
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    // Get the new SKU from the event's variant resource
    // @ts-ignore - sku property exists on variant but not in base type definition
    const newSku = event.detail.resource?.sku;

    if (newSku !== undefined) {
      // Update the SKU text in the specific element
      const skuValue = this.querySelector('#sku-block__value');
      if (skuValue) {
        skuValue.textContent = newSku;
      }
    }
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}
